import React, { Component } from 'react'

export class Investors extends Component {
  render() {
    return (
      <div>Investors</div>
    )
  }
}

export default Investors